import $ from 'jquery';
import '../vendor/select2/select2';

function SelectBox(element) {
  this.$element = $(element);
  this.create();
}

SelectBox.prototype = {
  create() {
    const $links = this.$element.find('.node-links');
    const $select = $('<select class="locations" data-placeholder="Select a County"></select>');
    const $list = $links.find('ul.links');
    const $options = $list.find('li:not(.link-read-more)');
    $select.append('<option selected disabled value="0">Select a County</option>');
    $options.each((i, item) => {
      const label = $(item).text();
      const value = $('a', item).attr('href');
      const option = `<option value="${value}">${label}</option>`;
      $select.append(option);
    });
    $select.insertBefore($list);
    $select.select2();
    $list.remove();
    // Add an on selection change event handler which redirects users to the
    // selected external county website.
    $select.on('select2:select', (event) => {
      const data = event.params.data;
      if (data && data.id) {
        window.open(data.id);
      }
    });
    // Add ready class to fade it in.
    $links.addClass('ready');
  },
};

export default SelectBox;



// WEBPACK FOOTER //
// ./SelectBox.js